import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { LikeStatus } from '../../../core/models/like-status.model';

@Injectable({
    providedIn: 'root',
})
export class TicketLikeService {
    constructor(private httpClient: HttpClient) {}

    changeLikeStatus(ticketId, socialMediaSourceId, isLiked): Observable<LikeStatus> {
        return this.httpClient.patch<any>(
            environment.apiInboxUrl +
                'tickets/' +
                ticketId +
                '/likes?socialMediaSourceId=' +
                socialMediaSourceId +
                '&isLiked=' +
                isLiked,
            null,
        );
    }
}
